<template>
  <div class="page">
    <Widgets :sportsBook="true" />
  </div>
</template>

<script>
import Widgets from "./Widgets";

export default {
  name: "Sportsbook",
  components: {
    Widgets
  }
};
</script>

<style>
  .page {
    height: 100%;
  }
</style>
